import { createAction, props, createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@ngrx/effects';
import { createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/internal/operators/map';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import * as i2 from 'step-status-update-payload-service';
import { of } from 'rxjs';
import { mergeMap as mergeMap$1, map as map$1, catchError } from 'rxjs/operators';

//Action to trigger get api call for sub task details
const loadSubTaskDetails = createAction('[SubTaskDetails] Load Visa SubTaskDetails', props());
//Action will be triggered on success of getSubTaskDetails api call
const loadSubTaskDetailsSuccess = createAction('[SubTaskDetails] Load Visa SubTaskDetails Success', props());
//Action will be triggered on failure of getSubTaskDetails api call
const loadSubTaskDetailsFailure = createAction('[SubTaskDetails] Load Visa SubTaskDetails Failure', props());

const subTaskDetailsFeatureKey = 'subTaskDetails';
const initialState$1 = {};
const subTaskDetailsReducer = createReducer(initialState$1, on(loadSubTaskDetailsSuccess, (state, { details }) => {
    return Object.assign(Object.assign({}, state), details);
}));

const updateStepStatus = createAction('[StepStatusUpdate] Update StepStatusUpdates', props());
const updateStepStatusSuccess = createAction('[StepStatusUpdate] Update StepStatusUpdates Success', props());
const updateStepStatusFailure = createAction('[StepStatusUpdate] Update StepStatusUpdates Failure', props());
const updateStepNotes = createAction('[StepStatusUpdate] Update StepNotes', props());
const updateStepStatusToInitialState = createAction('[StepStatusUpdate] Update StepStatusUpdates InitialState');

const stepStatusUpdateFeatureKey = 'stepStatusUpdate';
const initialState = {};
const stepStatusUpdateReducer = createReducer(initialState, on(updateStepStatusSuccess, (state, { response }) => {
    return Object.assign(Object.assign({}, state), response);
}), on(updateStepStatusToInitialState, (state) => {
    return initialState;
}));
const updateNotesReducer = createReducer(initialState, on(updateStepNotes, (payload) => {
    return Object.assign(Object.assign({}, initialState), payload);
}));

const SET_VISATYPECODE = 'SET_VISATYPECODE';
const SET_FORMCREATIONTYPE = 'SET_FORMCREATIONTYPE';
const SET_DATASOURCECOUNTRYLIST = 'SET_DATASOURCECOUNTRYLIST';
const SET_STATELIST = 'SET_STATELIST';
class SetVisaTypeCode {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_VISATYPECODE;
    }
}
class SetFormCreationType {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_FORMCREATIONTYPE;
    }
}
class SetDataSourceCountryList {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_DATASOURCECOUNTRYLIST;
    }
}
class SetStateList {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_STATELIST;
    }
}

const visaDetailsFeatureKey = 'visaDetails';
const InitialTask = {
    visaTypeCode: null,
    formCreationType: null,
    dataSourceCountryList: null,
    stateList: []
};
function visaReducer(state = InitialTask, action) {
    switch (action.type) {
        case SET_VISATYPECODE:
            return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, state), { visaTypeCode: action.payload })));
        case SET_FORMCREATIONTYPE:
            return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, state), { formCreationType: action.payload })));
        case SET_FORMCREATIONTYPE:
            return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, state), { formCreationType: action.payload })));
        case SET_DATASOURCECOUNTRYLIST:
            return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, state), { dataSourceCountryList: action.payload && action.payload
                    .length > 0 ? JSON.parse(JSON.stringify(action.payload)) : null })));
        case SET_STATELIST:
            if (state.stateList
                .some(stateObj => action.payload.countryCode === stateObj.countryCode)) {
                return JSON.parse(JSON.stringify(Object.assign({}, state)));
            }
            else {
                return JSON.parse(JSON.stringify(Object.assign(Object.assign({}, state), { stateList: state.stateList && state.stateList.length > 0 ?
                        [...state.stateList, action.payload] : [action.payload] })));
            }
        default:
            return JSON.parse(JSON.stringify(Object.assign({}, state)));
    }
}

const storeFeatureKey = 'VisaFeature';
// Created subTaskDetails Feature Selector out of GCI140 state
const getGCI140Feature = createFeatureSelector(storeFeatureKey);
const getTaskState = createFeatureSelector('task');
const reducers = {
    [subTaskDetailsFeatureKey]: subTaskDetailsReducer,
    [stepStatusUpdateFeatureKey]: stepStatusUpdateReducer,
    [visaDetailsFeatureKey]: visaReducer,
};
const metaReducers = [];

class StepStatusUpdateEffects {
    constructor(actions$, apiService) {
        this.actions$ = actions$;
        this.apiService = apiService;
        this.subTaskDetailsEffect$ = createEffect(() => {
            return this.actions$.pipe(ofType(updateStepStatus), mergeMap((action) => this.apiService.updateStepStatus(action.visaType, action.subTaskId, action.stepId, action.payload).pipe(map((stepStatusResponse) => ({ type: '[StepStatusUpdate] Update StepStatusUpdates Success', response: stepStatusResponse })))));
        });
    }
}
StepStatusUpdateEffects.ɵfac = function StepStatusUpdateEffects_Factory(t) { return new (t || StepStatusUpdateEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.StepStatusUpdatePayloadService)); };
StepStatusUpdateEffects.ɵprov = i0.ɵɵdefineInjectable({ token: StepStatusUpdateEffects, factory: StepStatusUpdateEffects.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepStatusUpdateEffects, [{
        type: Injectable
    }], function () { return [{ type: i1.Actions }, { type: i2.StepStatusUpdatePayloadService }]; }, null); })();

class SubTaskDetailsEffects {
    constructor(actions$, apiService) {
        this.actions$ = actions$;
        this.apiService = apiService;
        this.subTaskDetailsEffect$ = createEffect(() => {
            return this.actions$.pipe(ofType(loadSubTaskDetails), mergeMap$1((action) => this.apiService.getVisaTask(action.taskId, action.visaTypeCode).pipe(map$1(details => ({ type: '[SubTaskDetails] Load Visa SubTaskDetails Success', details: details })), catchError((error) => of({ type: '[SubTaskDetails] Load Visa SubTaskDetails Failure', payload: error })))));
        });
    }
}
SubTaskDetailsEffects.ɵfac = function SubTaskDetailsEffects_Factory(t) { return new (t || SubTaskDetailsEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.StepStatusUpdatePayloadService)); };
SubTaskDetailsEffects.ɵprov = i0.ɵɵdefineInjectable({ token: SubTaskDetailsEffects, factory: SubTaskDetailsEffects.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskDetailsEffects, [{
        type: Injectable
    }], function () { return [{ type: i1.Actions }, { type: i2.StepStatusUpdatePayloadService }]; }, null); })();

// return whether status update is succesful or failure
const getStepStatusUpdate = createSelector(getGCI140Feature, (state) => {
    return state.stepStatusUpdate;
});

//Creating subTaskDetails Selector using subTaskDetails Feature Selector
// return complete sub task details
const getSubTaskDetails = createSelector(getGCI140Feature, (state) => {
    return state.subTaskDetails;
});
//Get Step List out of Sub Task Details
// Returns the step list
const getSubTaskStepList = createSelector(getSubTaskDetails, (state) => {
    return state.taskStepDetails;
});
//Get specific step put of Step list
// Returns the step details based on step code
const getStepDetails = createSelector(getSubTaskStepList, (stepList, props) => {
    return stepList.find(x => x.id === props.id);
});
const getSuperTask = createSelector(getTaskState, (state) => state.taskSummaryOverview ? state.taskSummaryOverview.superTask : null);
const getSubTaskList = createSelector(getTaskState, (state) => state.taskSummaryOverview ? state.taskSummaryOverview.subTaskList : null);

const getVisaDetails = createSelector(getGCI140Feature, (state) => {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.visaDetails) !== null && _a !== void 0 ? _a : null;
});
const getVisaTypeCode = createSelector(getVisaDetails, (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.visaTypeCode) !== null && _a !== void 0 ? _a : null; });
const getFormCreationType = createSelector(getVisaDetails, (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.formCreationType) !== null && _a !== void 0 ? _a : null; });
const getDataSourceCountryList = createSelector(getVisaDetails, (state) => {
    var _a;
    return ((_a = state === null || state === void 0 ? void 0 : state.dataSourceCountryList) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
        JSON.parse(JSON.stringify(state.dataSourceCountryList)) : null;
});
const getStateList = createSelector(getVisaDetails, (state, props) => {
    var _a;
    return ((_a = state === null || state === void 0 ? void 0 : state.stateList) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
        (state.stateList.some(x => x.countryCode === props.countryCode) ?
            state.stateList.find(x => x.countryCode === props.countryCode).stateList : null)
        : null;
});

/*
 * Public API Surface of visa-store
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SET_DATASOURCECOUNTRYLIST, SET_FORMCREATIONTYPE, SET_STATELIST, SET_VISATYPECODE, SetDataSourceCountryList, SetFormCreationType, SetStateList, SetVisaTypeCode, StepStatusUpdateEffects, SubTaskDetailsEffects, getDataSourceCountryList, getFormCreationType, getGCI140Feature, getStateList, getStepDetails, getStepStatusUpdate, getSubTaskDetails, getSubTaskList, getSubTaskStepList, getSuperTask, getTaskState, getVisaDetails, getVisaTypeCode, loadSubTaskDetails, loadSubTaskDetailsFailure, loadSubTaskDetailsSuccess, metaReducers, reducers, stepStatusUpdateFeatureKey, stepStatusUpdateReducer, storeFeatureKey, subTaskDetailsFeatureKey, subTaskDetailsReducer, updateNotesReducer, updateStepNotes, updateStepStatus, updateStepStatusFailure, updateStepStatusSuccess, updateStepStatusToInitialState, visaDetailsFeatureKey, visaReducer };
//# sourceMappingURL=visa-store.js.map
